__turbopack_context__.v({
  "arrow": "Cta-module-scss-module__TYnfAa__arrow",
  "main": "Cta-module-scss-module__TYnfAa__main",
  "no-icon": "Cta-module-scss-module__TYnfAa__no-icon",
  "theme-dark": "Cta-module-scss-module__TYnfAa__theme-dark",
  "theme-filled": "Cta-module-scss-module__TYnfAa__theme-filled",
});
